import "./PastClients.css";
import alydiaHealth from "../images/clientlogos/alydia health.avif";
import aptusEndosystems from "../images/clientlogos/Aptus.avif";
import arrinex from "../images/clientlogos/Arrinex.avif";
import atheromed from "../images/clientlogos/Atheromed.avif";
import calaHealth from "../images/clientlogos/Cala Health.avif";
import flosonicsMedical from "../images/clientlogos/Flosonics.avif";
import intersectENT from "../images/clientlogos/intersect ENT.avif";
import iRhythm from "../images/clientlogos/iRhythm.avif";
import iridex from "../images/clientlogos/Iridex.avif";

const clients = [
  {
    id: "alydia-health",
    name: "Alydia Health",
    logo: alydiaHealth,
    category: "Commercial operations",
    summary:
      "Alydia Health engaged Ammen Consulting pre-FDA approval to establish commercial operations, including customer service SOPs and early implementation of Salesforce.com for sales and marketing. As the organization expanded, Ammen Consulting took over customer service and adapted Salesforce to align with evolving sales strategies. They also supported the post-acquisition integration with Organon in sales operations and customer service.",
  },
  {
    id: "aptus-endosystems",
    name: "Aptus Endosystems",
    logo: aptusEndosystems,
    category: "Revenue + compliance",
    summary:
      "Ammen Consulting transformed Aptus Endosystems' inefficient customer service processes, ensuring appropriate revenue recognition and compliance with FDA traceability requirements for a Class II device. They leveraged market data for strategic hiring, managed customer service, and provided comprehensive sales analysis and operations support. Ammen Consulting also supported Aptus through its integration with Medtronic post-acquisition.",
  },
  {
    id: "arrinex",
    name: "Arrinex",
    logo: arrinex,
    category: "Launch readiness",
    summary:
      "Arrinex partnered with Ammen Consulting to develop a scalable sales and customer service process ahead of commercial launch. The firm ensured seamless integration between Salesforce and customer service tools, refining processes to support rapid market adoption. Ammen Consulting also facilitated data-driven decision-making for optimized sales execution.",
  },
  {
    id: "atheromed",
    name: "Atheromed",
    logo: atheromed,
    category: "Sales operations",
    summary:
      "Ammen Consulting helped Atheromed establish robust customer service workflows and sales operations, ensuring compliance and efficiency. Their expertise supported sales growth, data analytics, and a successful acquisition transition.",
  },
  {
    id: "cala-health",
    name: "Cala Health",
    logo: calaHealth,
    category: "CRM optimization",
    summary:
      "Ammen Consulting worked closely with Cala Health to optimize sales operations, enhance CRM functionality, and develop scalable customer service solutions. They played a key role in ensuring compliance and seamless integration of new sales tools.",
  },
  {
    id: "flosonics-medical",
    name: "Flosonics Medical",
    logo: flosonicsMedical,
    category: "Analytics",
    summary:
      "Flosonics Medical leveraged Ammen Consulting’s expertise in sales data analytics and operations to refine market strategies and enhance customer engagement processes. The partnership drove operational efficiency and revenue growth.",
  },
  {
    id: "intersect-ent",
    name: "Intersect ENT",
    logo: intersectENT,
    category: "Workflow integration",
    summary:
      "Ammen Consulting supported Intersect ENT in streamlining sales and customer service workflows. Their expertise in Salesforce integration and data analytics provided actionable insights for sales and marketing teams.",
  },
  {
    id: "irhythm",
    name: "iRhythm",
    logo: iRhythm,
    category: "Forecasting",
    summary:
      "iRhythm partnered with Ammen Consulting to improve sales forecasting, CRM optimization, and customer service automation. Their collaboration ensured enhanced operational efficiency and strategic sales execution.",
  },
  {
    id: "iridex",
    name: "Iridex",
    logo: iridex,
    category: "Commercial support",
    summary:
      "Ammen Consulting helped Iridex refine its sales and service strategies, ensuring smooth CRM workflows and compliance. Their expertise supported the company in achieving improved sales analytics and customer engagement.",
  },
];

const PastClients = () => {
  return (
    <section id="past-clients" className="clients-section">
      <div className="section-shell">
        <div className="clients-header">
          <span className="eyebrow">Hear about some of our Clients</span>
          <h2 className="section-heading">Unparalleled Breadth of experience across a wide range of medtech categories and growth stages.</h2>
          <p className="section-intro">
            The work spans commercialization strategy, CRM design/implementation/management, customer
            service operations, analytics investigation, sales reporting, and acquisition support.<br />
            Each engagement may wear a different hat, but the common thread is operational
            discipline that makes growth easier to manage.
          </p>
        </div>

        <div className="clients-grid">
          {clients.map((client) => (
            <article key={client.id} className="client-card surface-card" onMouseLeave={(e) => e.currentTarget.scrollTo({ top: 0, behavior: "smooth" })}>
              <div className="client-card__top">
                <img src={client.logo} alt={client.name} className="client-logo" />
                <span className="pill">{client.category}</span>
              </div>
              <h3>{client.name}</h3>
              <p>{client.summary}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PastClients;
